import { BaseError } from "./BaseError";
export class RequestCancelError extends BaseError {
    constructor(message){
        super(message, true);
        // Set the prototype explicitly immediately after super()
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, RequestCancelError.prototype);
        this.name = "CANCELLED";
    }
}
